import { useMemo } from 'preact/hooks'
import { renderStyles } from '../../assets/styles'
import { WidgetInstance } from '../../types'
import { UserStyle } from './UserStyle'
import { useStyleData } from './useStyleData'
import { getHostStyles } from './hostStyles'

interface Props {
  widget: WidgetInstance
  inline: boolean
}

export function Styles({ widget, inline }: Props) {
  const styleData = useStyleData(widget)
  const hostStyles = useMemo(() => getHostStyles(styleData), [styleData])
  const baseStyles = useMemo(() => renderStyles(widget.layout, inline), [widget.layout, inline])

  return (
    <>
      <style>{hostStyles}</style>
      <style>{baseStyles}</style>
      <UserStyle css={styleData.css} />
    </>
  )
}
